import clsx from "clsx";
import React from "react";
import Image from "react-bootstrap/Image";
import * as dashboardSelectors from "../../selectors/dashboard";
import { getMarginSummaryMarginCallDateText, getMarginSummaryMarginShortfallFullText } from "../../selectors/dashboard";

function CustomCardActionRequired({ data }) {
        const clientCode = dashboardSelectors.getMarginSummaryClientCode(data)
        const callDateText = dashboardSelectors.getMarginSummaryMarginCallDateText(data)
        const marginSummaryMarginShortfallFullText = dashboardSelectors.getMarginSummaryMarginShortfallFullText(data)
  return (
    <div className="shadow mt-4 mb-5">
      <div className={clsx("custom-card-action-required-label-container d-flex align-items-center")}>
        <Image src="/img/icon/chat-alert-outline.png" rounded />
        <h2>Action Required</h2>
      </div>
      <div className={clsx("custom-card-label-action-required-container")}>
        <div className="notes-text-bold">Note:</div>
        <div className="notes-text-bold">1. If you had regularised the shortfall kindly ignore the notice below</div>
        <div className="notes-text-bold">2. The latest margin position can be viewed in Margin Statement</div>
        <div className="notes-text-bold mt-3">SHORTFALL IN MARGIN TRADING ACCOUNT NO. {clientCode}</div>
        <p className="mt-3">We refer to your margin trading account and wish to inform you that as at {callDateText} there is a shortfall of {marginSummaryMarginShortfallFullText} in your account,</p>
        <p>Any shortfall must be covered within three (3) trading days from the date hereof (aforesaid period). Please take the necessary
          steps to regularise your margin Trading Account (as required pursuant to section 4.06 (2) of the Margin Trading Facility
          Agreement) by either depositing sufficient shares or such other collaterals which are acceptable to us or pay the shortfall
          amount into your Account within the aforesaid period.</p>
        <p>If you had received earlier notice(s) of this shortfall, then the aforesaid period does not apply. You are to rectify the shortfall
          immediately.</p>
        <p>In the event that the shortfall is not covered within the aforesaid period, we shall have no alternative but to sell such amount
          of your shares to cover the shortfall as permitted under the BMSB Rules and pursuant to section 4.06 (3) of the Margin
          Trading Facility Agreement.</p>
        <p>However, if you had regularised the shortfall kindly ignore this notice.</p>
        <p>This letter is without prejudice to any of our rights and powers under or pursuant to the Margin Trading Facility Agreement
          (as may be varied and/or amended from time to time).</p>
      </div>
    </div>
  );
}

export default CustomCardActionRequired;
